import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const acatoVariables = acato_variables || {}; // Passed by wp_localize_script.

const initLightboxSwiper = () => {
  document.querySelectorAll( '.lightbox' ).forEach( (lightbox) => {
    const swiperElement = lightbox.querySelector( '.lightbox__swiper' );
    const thumbsElement = lightbox.querySelector( '.lightbox__thumbnails' );

    if (!swiperElement) {
      return;
    }

    // Move the slides out of the DOM right away. Virtual slides re-insert
    // only a few at a time, which keeps iOS Safari within its per-tab
    // memory limit on large galleries.
    const wrapper = swiperElement.querySelector( '.swiper-wrapper' );
    const virtualSlides = Array.from( wrapper.children ).map( (slide) => slide.outerHTML );
    wrapper.textContent = '';

    let lightboxSwiper = null;

    const initSwipers = () => {
      const lightboxThumbs = thumbsElement
        ? new Swiper( thumbsElement, {
          spaceBetween: 24,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
        } )
        : null;

      lightboxSwiper = new Swiper( swiperElement, {
        a11y: {
          enabled: true,
          firstSlideMessage: acatoVariables.slider_first_slide_message || 'First slide',
          lastSlideMessage: acatoVariables.slider_last_slide_message || 'Last slide',
          nextSlideMessage: acatoVariables.slider_next_slide_message || 'Next slide',
          prevSlideMessage: acatoVariables.slider_previous_slide_message || 'Previous slide',
          slideLabelMessage: acatoVariables.slider_slide_label_message || 'Slide {{index}} of {{slidesLength}}',
        },
        loop: true,
        lazyPreloadPrevNext: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        thumbs: lightboxThumbs ? { swiper: lightboxThumbs } : undefined,
        virtual: {
          slides: virtualSlides,
          renderSlide: (slide) => slide,
        },
      } );
    };

    // A <dialog> exposes no reliable open event, so watch its open
    // attribute. Initializing after showModal() also means Swiper
    // measures a visible dialog instead of a display:none one.
    const observer = new MutationObserver( () => {
      if (!lightbox.open) {
        return;
      }

      if (lightboxSwiper) {
        lightboxSwiper.update();
      } else {
        initSwipers();
      }
    } );

    observer.observe( lightbox, { attributeFilter: [ 'open' ] } );
  } );
}

const init = () => {
  initLightboxSwiper();
};

export default init;
